import { makeStyles } from "@material-ui/core";

export const useUsersStatusIcon = makeStyles((theme) => ({
  primary: {
    color: theme.palette.primary.main,
  },
  warning: {
    color: theme.palette.warning.main,
  },
  success: {
    color: theme.palette.success.main,
  },
  error: {
    color: theme.palette.error.main,
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: 12,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  statusLabel: {
    fontSize: 12,
  },
  largeStatusLabel: {
    fontSize: 12,
  },
}));
